import React from 'react';
import {
  Home as HomeIcon,
  FilterNone as UIElementsIcon,
  BorderAll as TableIcon,
  QuestionAnswer as SupportIcon,
  LibraryBooks as LibraryIcon,
  HelpOutline as FAQIcon,
  BarChart as ChartIcon,
  Map as MapIcon,
  LocationOn,
  Apps as CoreIcon,
  Description as DescriptionIcon,
  ShoppingCart as ShoppingCartIcon,
  StarBorder as ExtraIcon,
  AddCircle as AddSectionIcon,
  FolderOpen as FolderIcon,
  Description as DocumentationIcon,
  Person as PersonIcon,
  AccountCircle,
  AccountCircle as ProfileIcon,
  Store,
  Business,
  Inventory,
  ShoppingCart,
  People,
  PersonAdd,
  Group,
  SupervisorAccount,
  PointOfSale,
  Security,
  Work,
  AdminPanelSettings,
  Lock,
  MasterCard,
  Groups,
  TrendingUp,
  EmojiEvents,
  Assessment,
  Payment,
  AccountBalance,
  Analytics,
  BusinessCenter,
  SwapHoriz,
  Dashboard,
  SupportAgent,
  WbSunny,
  ElectricalServices,
  BatteryChargingFull,
  Build,
  Engineering,
  Assignment as ProjectIcon,
  Settings,
  AdminPanelSettings as AdminIcon,
  AccountCircle as TechnicianIcon,
  ContactPage as LeadIcon,
  Timeline as TimelineIcon,
  Campaign as AnnouncementIcon,
  Share as ShareIcon,
  Facebook as FacebookIcon,
  Language as WebIcon,
} from '@mui/icons-material';
import ChatIcon from '@mui/icons-material/Chat';
import ViewCompactRoundedIcon from '@mui/icons-material/ViewCompactRounded';
import {
  Receipt as ReceiptIcon,
  CreditCard,
  ContactPage,
  LocalShipping,
  Assignment,
  RequestQuote,
  Inventory2,
  CardGiftcard,
  Stars,
  Redeem,
  History,
  Rule,
  Cancel,
  AccountBalanceWallet,
  Calculate,
  Percent,
  Payments,
  HomeWork,
} from '@mui/icons-material';

// components
import Dot from './components/Dot';

// Import menu filtering utilities
import { getFilteredStructure } from '../../utils/menuFilter';

const structure = [
  // ========================================
  // DASHBOARD
  // ========================================
  { id: 0, label: 'Dashboard', link: '/app/dashboard', icon: <HomeIcon /> },
  // ========================================
  // REAL ESTATE MANAGEMENT
  // ========================================
  {
    id: 0.5,
    label: 'Real Estate Management',
    children: [
      // Master Data
      {
        id: 1,
        label: 'Master',
        badgeColor: 'success',
        link: '/app/master',
        icon: <Settings />,
        children: [
          {
            label: 'General Master',
            link: '/app/ecommerce/generalMaster',
          },
          {
            label: 'Announcements',
            link: '/app/announcement',
          },
          // {
          //   label: 'Setting',
          //   link: '/app/setting',
          // },
        ],
      },

      // Organization Management
      // {
      //   id: 2,
      //   label: 'Organization Master',
      //   link: '/app/organization',
      //   badgeColor: 'secondary',
      //   icon: <PersonAdd />,
      //   children: [
      //     {
      //       label: 'Organization Profile',
      //       link: '/app/organization/OrganizationProfile',
      //     },
      //     {
      //       label: 'Business',
      //       link: '/app/organization/Business',
      //     },
      //     {
      //       label: 'Branch Setup',
      //       link: '/app/organization/BranchSetup',
      //     },
      //     {
      //       label: 'Department Setup',
      //       link: '/app/organization/DepartmentSetup',
      //     },
      //     {
      //       label: 'Designation Setup',
      //       link: '/app/organization/DesignationSetup',
      //     },
      //     {
      //       label: 'Policy',
      //       link: '/app/organization/Policy',
      //     },
      //   ],
      // },


      // Profile
      {
        id: 4,
        label: 'Profile',
        link: '/app/profile/myProfile',
        icon: <ProfileIcon />,
        children: [
          {
            label: 'My Profile',
            link: '/app/profile/myProfile',
          },
          // {
          //   label:'My Business',
          //   link:'/app/profile/myBusiness'
          // },
          // {
          //   label:'Payment History',
          //   link:'/app/profile/paymentHistory'
          // }
        ],
      },

      // Member Management
      {
        id: 5,
        label: 'Members',
        link: '/app/members',
        badgeColor: 'secondary',
        icon: <People />,
        children: [
          {
            label: 'Customer Details',
            link: '/app/members/Customer',
          },
        ],
      },

      // Associate Management
      {
        id: 3,
        label: 'Associate',
        link: '/app/users/AssociateList',
        badgeColor: 'secondary',
        icon: <Group />,
        children: [
          {
            label: 'Associate List',
            link: '/app/users/AssociateList',
          },
          {
            label: 'Associate Registration',
            link: '/app/user/AssociateRegistration',
          },
          {
            label: 'Associate Change',
            link: '/app/user/AssociateChange',
          },
          {
            label: 'Associate Tree',
            link: '/app/users/AssociateTree',
          },
          {
            label: 'Associate Commission',
            link: '/app/users/AssociateCommission',
          },
          {
            label: 'Old Business',
            permission: 'associate.old-business',
            hidden: true,
          },
        ],
      },

      {
        id: 3.2,
        label: 'My Business',
        link: '/app/profile/myBusiness',
        icon: <BusinessCenter />
      },

      {
        id: 3.3,
        label: 'Payment History',
        link: '/app/profile/paymentHistory',
        icon: <History />
      },
      {
        id: 3.4,
        label: 'My Team',
        link: '/app/users/MyTeam',
        icon: <Group />,
        permission: 'my-team.my-team'
      },

      // My Achievement
      {
        id: 3.1,
        label: 'My Achievement',
        link: '/app/achievements/my-reward',
        icon: <EmojiEvents />,
      },

      // Promotion Management
      {
        id: 7,
        label: 'Promotion Mgt',
        link: '/app/promotion',
        icon: <TrendingUp />,
        children: [
          {
            label: 'Rewards & Incentives',
            link: '/app/promotion/reward-list',
          },
          {
            label: 'Level Reward',
            link: '/app/promotion/level-reward',
          },
          {
            label: 'Incentive',
            link: '/app/promotion/incentive',
          },
          {
            label: 'Reward Approve',
            link: '/app/promotion/reward-approve',
          },
        ],
      },







      // Employee Management
      // {
      //   id: 6,
      //   label: 'Employee',
      //   link: '/app/employee',
      //   badgeColor: 'secondary',
      //   icon: <People />,
      //   children: [
      //     {
      //       label: 'Employee List',
      //       link: '/app/employee/Employee',
      //     },
      //   ]
      // },

      // User Permission Management
      // User Permission removed from sidebar

      // Project Management
      {
        id: 8,
        label: 'Project',
        icon: <Groups />,
        link: '/app/project',
        children: [
          {
            label: 'Project List',
            link: '/app/project/ProjectList',
          },
          {
                label: 'Plot List',
                link: '/app/project/PlotListDetails',
          },
          {
            label: 'Row House',
            link: '/app/project/rowhouse',
          },
          {
            label: 'Apartment / Commercial',
            link: '/app/project/apartment',
            children: [
              {
                label: 'Building List',
                link: '/app/project/apartment/buildings',
              },
              {
                label: 'Floor List',
                link: '/app/project/apartment/floors',
              },
              {
                label: 'Flat List',
                link: '/app/project/apartment/flats',
              },
            ],
          },
          {
            label: 'Villa',
            link: '/app/project/ProjectEnquiry',
          },
        ],
      },
      // Lead Management
      {
        id: 10,
        label: 'Lead',
        icon: <LeadIcon />,
        link: '/app/lead',
        badgeColor: 'primary',
        children: [
          {
            label: 'Lead List',
            link: '/app/lead/LeadList',
          },
          {
            label: 'Lead Timeline',
            link: '/app/lead/LeadTimeline',
          },
        ],
      },

      // Visit Site
      { id: 10.1, label: 'Visit Site', link: '/app/siteVisit/SiteVisit', icon: <LocationOn /> },

      { id: 10.2, label: 'Funnel Leads', link: '/app/funnel', icon: <TimelineIcon /> },

      // Booking Management
      {
        id: 11,
        label: 'Booking',
        link: '/app/booking',
        badgeColor: 'secondary',
        icon: <Business />,
        children: [
          {
            label: 'Add Booking',
            link: '/app/booking/AddBooking',
          },
          {
            label: 'Booking Details',
            link: '/app/booking/BookingDetail',
          },
          {
            label: 'Booking Approval',
            link: '/app/booking/BookingApproval',
          },
          {
            label: 'Receipt Approval',
            link: '/app/booking/ReceiptApproval'
          },
          {
            label: 'Commission',
            permission: 'booking.commission',
            hidden: true,
          },
          {
            label: 'Followup/Remark',
            permission: 'booking.followup',
            hidden: true,
          },
          {
            label: 'Receipt',
            permission: 'booking.receipt',
            hidden: true,
          },
          {
            label: 'Refund Receipt',
            permission: 'booking.refund-receipt',
            hidden: true,
          },
          {
            label: 'Document',
            permission: 'booking.document',
            hidden: true,
          },
          {
            label: 'Progress',
            permission: 'booking.progress',
            hidden: true,
          },
          {
            label: 'Booking Status',
            permission: 'booking.booking-status',
            hidden: true,
          },
          {
            label: 'Cancel Booking',
            permission: 'booking.cancel-plot-booking',
            hidden: true,
          },
          // {
          //   label: 'Allotment Payment',
          //   link: '/app/plotbooking/AllotmentPayment',
          // },
          // {
          //   label: 'Booking Registry',
          //   link: '/app/plotbooking/PlotRegistry',
          // },
        ],
      },

      // {
      //   id: 11.1,
      //   label: 'Admin Payment',
      //   link: '/app/adminPayment',
      //   icon: <Payments />
      // },

      {
        id: 8.61,
        label: 'Payment Associate',
        link: '/app/payment-associate',
        icon: <AccountBalanceWallet />,
        children: [
          {
            label: 'Payment Associate',
            link: '/app/payment-associate',
          },
          // {
          //   label: 'Pay Incentive',
          //   link: '/app/pay-incentive',
          //   permission: 'payment-associate',
          // },
          {
            label: 'Payment Details',
            link: '/app/paymentAssociate/List',
          },
        ],
      },

      // Commission Generation
      { id: 8.7, label: 'Commission Generation', link: '/app/commissionGenerate/CommissionGenerate', icon: <Calculate /> },



      //Inventory
      { id: 8.5, label: 'Inventory', link: '/app/inventory', icon: <Inventory2 /> },

      //Purchase
      {
        id: 8.6,
        label: 'Purchase',
        link: '/app/purchase',
        icon: <HomeWork />,
        children: [
          {
            label: 'Purchase',
            link: '/app/purchase/farmer',
          },
          {
            label: 'Farmer Ledger',
            link: '/app/purchase/FarmerLedger',
          },
        ],
      },
      // { id: 8.1, label: 'Purchase', link: '/app/Purchase', icon: <Groups /> },

      // payment to associate




      // Reward Management
      {
        id: 12,
        label: 'Rewards',
        link: '/app/reward',
        icon: <EmojiEvents />,
        badgeColor: 'warning',
        children: [
          // {
          //   label: 'Reward list',
          //   link: '/app/reward/reward-list',
          // },
          // {
          //   label: 'Level Reward',
          //   link: '/app/reward/level-reward',
          // },
          // {
          //   label: 'Reward Approval',
          //   link: '/app/reward/reward-approve',
          // },
          // {
          //   label: 'Incentive Structure',
          //   link: '/app/reward/incentive',
          // },
          {
            label:'Reward Category',
            link: '/app/reward/reward-category',
          },
          {
            label: 'History Reward',
            link: '/app/reward/history-reward',
          },
          {
            label: 'Redeem Requests',
            link: '/app/reward/redeem-requests',
          },
          {
            label: 'Reward Transaction',
            link: '/app/reward-transaction',
          },
          // {
          //   label: 'Add Reward',
          //   link: '/app/reward/add-reward',
          // },
        ],
      },


      // Payout Management
      // {
      //   id: 13,
      //   label: 'Payout',
      //   link: '/app/payout',
      //   icon: <Payment />,
      //   children: [
      //     {
      //       label: 'Payout Report for Bank',
      //       link: '/app/payout/PayoutReportForBank',
      //     },
      //     {
      //       label: 'Consolidated Payout Report',
      //       link: '/app/payout/ConsolidatedPayoutReport',
      //     },
      //     {
      //       label: 'TDS Report',
      //       link: '/app/payout/TDSReport',
      //     },
      //   ],
      // },

      // Reports
      {
        id: 14,
        label: 'Reports',
        link: '/app/reports',
        icon: <Assessment />,
        children: [
          // Commission Reports
          {
            label: 'Associate',
            icon: <People />,
            children: [
              {
                label: 'Commission Report',
                link: '/app/reports/CommissionReport',
              },
              {
                label: 'Follow-up Report',
                link: '/app/reports/FollowupReport',
              },
              {
                label: 'Associate Ledger',
                link: '/app/reports/AssociateLedger'
              },
              {
                label: 'TDS Report',
                link: '/app/reports/TDS'
              }
            ],
          },

          // Booking Reports
          {
            label: 'Booking',
            icon: <ReceiptIcon />,
            children: [
              {
                label: 'Booking Report',
                link: '/app/reports/BookingReport',
              },
              {
                label: 'Booking Commission',
                link: '/app/reports/BookingCommission',
              },
              {
                label: 'Booking Receipt',
                link: '/app/reports/BookingReceipt',
              },
              {
                label: 'Cancel Report',
                link: '/app/reports/CancelReport',
              }
            ],
          },

          // Accounts Reports
          {
            label: 'Accounts',
            icon: <Payments />,
            permission: 'reports.booking',
            children: [
              {
                label: 'Admin Payment',
                link: '/app/adminPayment',
                permission: 'reports.booking',
              }
            ],
          },

          // Customer Reports
          {
            label: 'Customer',
            icon: <PersonIcon />,
            children: [
              {
                label: 'Customer Ledger',
                link: '/app/reports/CustomerLedger',
              },
            ],
          },

          // Lead Reports
          {
            label: 'Lead',
            icon: <ContactPage />,
            children: [
              {
                label: 'Lead Report',
                link: '/app/reports/LeadReport',
              },
            ],
          },


          // Branch Reports
          {
            label: 'Project',
            icon: <Business />,
            children: [
              {
                label: 'Project Wise Summary',
                link: '/app/reports/BranchWiseSummary',
              },
              // {
              //   label: 'Project Summary Details',
              //   link: '/app/reports/BranchSummaryDetails',
              // },
            ],
          },

          // EMI Reports
          // {
          //   label: 'EMI',
          //   icon: <CreditCard />,
          //   children: [
          //     {
          //       label: 'EMI Report',
          //       link: '/app/reports/EMIReport',
          //     },
          //   ],
          // },

          // {
          //   label: 'Project Report',
          //   icon: <ProjectIcon />,
          //   children: [
          //     {
          //       label: 'Project Report',
          //       link: '/app/reports/ProjectReport',
          //     },
          //   ],
          // },
        ],
      },
      {
        id: 0.1,
        label: 'Associate Credentials',
        link: '/app/users/AssociateCredentials',
        icon: <ContactPage />,
        permission: 'associate.associate-credentials'
      },

      { id: 0.6, label: 'Activity Logs', link: '/app/activity-logs', icon: <History /> },

      {
        id: 0.7,
        label: 'Integration',
        icon: <ShareIcon />,
        children: [
          {
            label: 'Facebook',
            link: '/app/social/facebook',
            icon: <FacebookIcon />,
          },
          {
            label: 'Website',
            link: '/app/social/website',
            icon: <WebIcon />,
          },
        ],
      },
     
    ],
  },

  

  
  
];

// Export the raw structure - filtering will be done in the Sidebar component
export const settingsSidebarStructure = [
  {
    id: 100,
    label: 'Back to Dashboard',
    link: '/app/dashboard',
    icon: <HomeIcon />,
  },
  {
    id: 101,
    type: 'divider',
  },
  {
    id: 102,
    label: 'Commission',
    link: '/app/setting',
    icon: <Settings />,
    children: [
      {
        label: 'Commission Setting',
        link: '/app/setting/commission',
      },
      {
        label: 'Reward Setting',
        link: '/app/setting/reward',
      },
      {
        label: 'Incentive Setting',
        link: '/app/setting/incentive',
      },
      // {
      //   label: 'Level Structure',
      //   link: '/app/setting/level-structure',
      // },
    ],
  },
];

export default structure;
